import { Injectable } from "@angular/core";
import { InternalError } from "common";
import { Observable, throwError } from "rxjs";
import { ElectronService } from "src/app/electron/services/electron.service";
import { PortalConfig } from "../model/config";

@Injectable()
export class ConfigElectronService {
    constructor(private electronService: ElectronService) { }

    getConfigPortal(): Observable<PortalConfig> {
        if (this.electronService.isElectronApp) {
          return this.electronService.invoke<PortalConfig>('get-config');
        } else {
          return throwError(() =>
            new InternalError('CONFIG_0004', 'No se puede obtener la configuracion', undefined, undefined));
        }
      }

      saveConfigPortal(data: PortalConfig): Observable<PortalConfig> {
        if (this.electronService.isElectronApp) {
          return this.electronService.invoke<PortalConfig>('save-config', data);
        } else {
          return throwError(() =>
            new InternalError('CONFIG_0004', 'No se puede guardar la configuracion', undefined, undefined));
        }
      }
}